import styled, { css, DefaultTheme } from 'styled-components';
import { defaultTheme } from '@styles/theme.styled';

// Memoize the twin styling to prevent recalculation on every render
const twinStyling = (() => {
  const theme = defaultTheme;
  const styles = Object.keys(theme.backgroundColors)
    .map(
      (color) => `
        &.section-${color} + .section-${color} {
          padding-top: 0;
        }
      `
    )
    .join('');

  return css`
    ${styles}
  `;
})();

interface SectionProps {
  backgroundColor: keyof typeof defaultTheme.backgroundColors;
  theme: DefaultTheme;
}

// Optimize media queries by using a single breakpoint object
const mediaQueries = {
  xl: (theme: DefaultTheme) => `@media only screen and (max-width: ${theme.breakpoints.xl})`,
  lg: (theme: DefaultTheme) => `@media only screen and (max-width: ${theme.breakpoints.lg})`,
  md: (theme: DefaultTheme) => `@media only screen and (max-width: ${theme.breakpoints.md})`,
  sm: (theme: DefaultTheme) => `@media only screen and (max-width: ${theme.breakpoints.sm})`,
};

export const StyledSection = styled.section<SectionProps>`
  ${({ theme, backgroundColor }) => css`
    width: 100%;
    position: relative;
    background: ${theme.backgroundColors[backgroundColor]};
    padding: 5rem 0;
    overflow: hidden;

    ${mediaQueries.xl(theme)} {
      padding: 4rem 0;
    }

    ${mediaQueries.lg(theme)} {
      padding: 3.5rem 0;
    }

    ${mediaQueries.md(theme)} {
      padding: 3.25rem 0;
    }

    ${mediaQueries.sm(theme)} {
      padding: 3rem 0;
    }

    ${twinStyling}
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    z-index: ${theme.zIndex.layeredContent};
    position: relative;
  `}
`;
